// extracted by mini-css-extract-plugin
export default {"verification_container":"accountVerification_verification_container__08l1K"};